<template>
  <div id="app" v-bind:class=" $route.name ==='Project' ?  'app--project' : 'app--home'  ">
    <transition name="bg" appear>
      <div class="bg"></div>
    </transition>

    <div class="main_wrapper">

      <div class="header__fill"></div>
      <transition name="fix" appear>
        <div class="fix">
          <div class="mobile-mask"><p></p></div>
          <h3 class="top_title works__top_title typewriter">
            web & design
          </h3>
          <header class="header">
            <nav>
              <ul class="header__list">
                <li class="header__list-item header__list-item_logo">
                  <router-link :to="{ name: 'Home'}">
                    <img src="./assets/img/vendor/logo.svg" alt="logo">
                    <h2 class="hidden">x4</h2></router-link>
                </li>
                <li class="header__list-item">
                  <a href="/#work">Work</a>
                </li>
                <li class="header__list-item">
                  <a href="/#about">About</a>

                </li>
                <li class="header__list-item">
                  <a href="/#contacts">Contacts</a>
                  <!--<router-link :to="{ name: 'Home' }">Contacts</router-link>-->
                </li>
              </ul>
            </nav>
          </header>
          <div class="home__scroll">
            <svg width="194" height="100" viewBox="0 0 194 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>Path 3</title>
              <desc>Created using Figma</desc>
              <g id="scroll" >
                <g id="Path 3">
                  <use xlink:href="#path0_fill" fill="#fff"/>
                </g>
              </g>
              <defs>
                <path id="path0_fill" fill-rule="evenodd" d="M 43.7886 26.6932C 62.8323 18.1965 69.8057 5.43223e-16 93.8848 0C 116.077 0 124.078 23.2353 156.401 30.7002C 172.481 34.4138 183.743 34.4339 191.256 34.4138C 198.769 34.3936 182.123 35.2918 177.514 35.3135C 118.425 35.5918 59.33 35.6118 0.24122 35.3135C -0.891372 35.3077 2.27602 34.7271 3.29342 34.4339C 3.29342 34.4339 26.4844 34.4138 43.7886 26.6932Z"/>
              </defs>
            </svg>

          </div>
          <div class="home__lines">
            <img class="home__bg-line1" src="./assets/img/vendor/Line1.svg" alt="logo_line">
            <svg class="home__bg-line2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10" preserveAspectRatio="none">
              <polygon points="100 0 100 0 0 10" />
            </svg>
            <img class="home__bg-line3" src="./assets/img/vendor/Line3.svg" alt="logo_line">

          </div>

        </div>
      </transition>

      <router-view/>

    </div>
  </div>

</template>
<!--<script src="//cdnjs.cloudflare.com/ajax/libs/jquery.nicescroll/3.7.6/jquery.nicescroll.min.js"></script>-->

<script>
  import { TweenMax, TimelineMax } from 'gsap'

export default {
  name: 'app',
  watch: {
    '$route'(to, from) {
      if (from.name === 'Project') {
        window.can_scroll = false;
        setTimeout(function () {
          $('body').removeClass('bg_color')
        }, 500)
        setTimeout(function () {
          window.can_scroll = true;
        }, 2000)
      }

      if (from.name === 'page404') {

        $('body').removeClass('body_404')
      }
    }
  },
  created: function () {
    window.can_scroll = true;
    window.isSend = false;

  }
}
</script>


<style type="scss">
  @media screen and (min-width: 1024px) {
    .v-enter-active, .v-leave-active {
      transition-property: opacity;
      transition-duration: 200.8437923649918ms;
      transition-timing-function: ease-in-out;
    }

    .v-enter-active {
      transition-delay: 297.36780030118047ms;
    }

    .v-enter, .v-leave-active {
      opacity: 0
    }


    .bg-enter-active, .bg-leave-active {
      transition-property: opacity;
      transition-duration: 480.2420683876143ms;
    }

    .bg-enter-active {
      transition-delay: 432.35494653775874ms;
    }

    .bg-enter, .bg-leave-active {
      opacity: 0
    }

    .fix-enter-active, .fix-leave-active {
      /*transition-property: opacity;*/
      transition-duration: 342.6268656716418ms;
    }
    .fix-enter-active .home__lines, .fix-leave-active .home__lines {
      transition-duration: 437.9897821554911ms;
    }
    .fix-enter-active .home__lines {
      transition-delay: 720.9506076114949ms;
    }
    .fix-enter .home__lines, .fix-leave-active .home__lines {
      visibility: hidden;
    }

    .fix-enter-active {
      transition-delay: 170.9420895522388ms;

    }

    .fix-enter, .fix-leave-active {
      opacity: 0;
    }

  }
</style>

<style lang="scss" src="./assets/css/main.scss"></style>



// WEBPACK FOOTER //
// src/App.vue